import React from 'react'
import styled from "styled-components";
import { Dimmer, Loader, Header } from 'semantic-ui-react';
import { map } from 'lodash'

import { __ } from '~/i18n'

import { CheckoutButtons } from '~/components/checkout'
import { PaymentMethod } from '~/components/payment'
import MakeCommerceMethod from './make-commerce'
import PayseraMethod from './paysera'
import GratifyMethod from './gratify'
import logic from './logic'

const PaymentStepContainer = styled.div``;
const PaymentItemsContainer = styled.div`
  padding-top: 16px; 
`;

const methodMap = {
  'ShopMaksekeskusMethod': MakeCommerceMethod,
  'ShopPayseraMethod': PayseraMethod,
  'ShopGratifyMethod': GratifyMethod,
}

@logic
export default class PaymentStep extends React.PureComponent {

  handleContinue = () => {
    const { next } = this.props.actions;

    next();
  };

  handleSelect = (method, extra) => {
    const { selectPaymentMethod } = this.props.actions;
    selectPaymentMethod(method, extra);
  };

  render() {
    const {
      onBack, shopPaymentMethods, currentPaymentMethod, paymentMethodData, paymentMethodArguments, loading,
      cartLoading, showProvider
    } = this.props;

    const paymentItems = map(shopPaymentMethods, (paymentMethod) => {
      const active = currentPaymentMethod && (paymentMethod.url === currentPaymentMethod.url);

      const MethodClass = methodMap[paymentMethod.type] || PaymentMethod;

      return (
        <MethodClass
          key={ paymentMethod.id }
          paymentMethod={ paymentMethod }
          name={ paymentMethod.name }
          instructions={ paymentMethod.instructions }
          selectMethod={ this.handleSelect }
          active={ active }
          image={ paymentMethod.image }
          data={ paymentMethodData[paymentMethod.id] }
          args={ paymentMethodArguments }
          showProvider={ showProvider }
        />
      );
    });
    return (
      <PaymentStepContainer>
        <Header size='large'>{ __("Payment Method") }</Header>
        <Header.Subheader>{ __("Choose a payment method") }</Header.Subheader>

        <PaymentItemsContainer>
          <Dimmer inverted active={ loading }>
            <Loader />
          </Dimmer>
          { paymentItems }
        </PaymentItemsContainer>

        <CheckoutButtons
          onBack={ onBack }
          onContinue={ this.handleContinue }
          loading={ cartLoading }
          continueDisabled={ !currentPaymentMethod }
        />
      </PaymentStepContainer>
    )
  }
}
